import { render, staticRenderFns } from "./XFormSwitch.vue?vue&type=template&id=15e443c4&"
import script from "./XFormSwitch.vue?vue&type=script&lang=js&"
export * from "./XFormSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports